<template>
  <dashboard-module class="dashboard-item" title-slot v-loading="loading">
    <template #title>
      <i class="el-icon-bangzhu title-icon"></i>
      <span class="title-text">各部门情况</span>
    </template>
    <template #ope>
      <div class="flex">
        <div class="select-v2">
          <el-select class="query-item" v-model="queryParams.type" filterable @change="statsTypeChange">
            <el-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </div>
        <div class="date-picker-v2 has-icon ml16">
          <el-date-picker class="query-item" v-model="queryParams.month" type="month" format="yyyy-MM" value-format="yyyy-MM" :clearable="false" :picker-options="pickerOptions" @change="getData"></el-date-picker>
        </div>
        <el-radio-group class="radio-theme ml16" v-model="queryParams.statsType" size="small" text-color="#fff" fill="#FF9601" @change="statsTypeChange">
          <el-radio-button label="1">工资总额</el-radio-button>
          <el-radio-button label="2">固定工资及补贴</el-radio-button>
          <el-radio-button label="3">奖金</el-radio-button>
          <el-radio-button label="4">人工成本</el-radio-button>
        </el-radio-group>
      </div>
      <div></div>
    </template>
    <div class="chart" id="departmentChart"></div>
  </dashboard-module>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DashboardModule from './DashboardModule'
  import { formatNumber } from '@/filters'
  import { getDeptMonthLaborCostByYear } from '@/api/v2/stats/data-center/dashboard'
  import { validatenull } from "@/util/validate";

  export default {
    name: "Department",
    components: {
      DashboardModule
    },
    mounted() {
      this.$nextTick(() => {
        this.getData()
      })
    },
    data() {
      return {
        loading: false,
        chart: null,
        pickerOptions: {
          disabledDate(time){
            const curDate = new Date()
            const year = curDate.getFullYear()
            const month = curDate.getMonth() + 1
            return time.getTime() > new Date(`${ year }-${ month }`) || time.getTime() < new Date(`${ year - 2 }-01`)
          }
        },
        typeList: [
          { value: 1, label: '业务部门' },
          { value: 2, label: '职能部门' }
        ],
        queryParams: {
          type: 1,
          month: this.$day().format('YYYY-MM'),
          statsType: '1'
        },
        grid: {
          left: '1%',
          right: '2%',
          bottom: '10',
          containLabel: true
        },
        legend: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#d9d9d9',
            }
          },
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#d9d9d9'
            }
          },
          axisLabel: {
            color: '#333',
            lineHeight: 24,
            interval: 0,
            rotate: 30
          },
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: '部门总体工资',
            nameGap: 20,
            axisLabel: {
              formatter: '{value}W'
            }
          },
          {
            type: 'value',
            name: '部门人均工资',
            nameGap: 20,
            axisLabel: {
              formatter: '{value}W'
            },
            max: 200,
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '18px',
            label: {
              normal: {
                show: true,// 显示label
                position: "top", // 显示的label的位置
              }
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + 'W';
              }
            },
            data: []
          },
          {
            name: '',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: '18px',
            label: {
              normal: {
                show: true,// 显示label
                position: "top", // 显示的label的位置
              }
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + 'W';
              }
            },
            data: []
          }
        ],
        allData: {}
      }
    },
    methods: {
      getData() {
        this.loading = true
        const params = {
          month:  this.queryParams.month
        }
        getDeptMonthLaborCostByYear(params)
        .then(res => {
          this.loading = false
          this.allData = res.data.data
          this.statsTypeChange()
        })
        .catch(error => this.loading = false)
      },
      initChart() {
        let chartDom = document.getElementById("departmentChart");
        if (chartDom == null) {
          return
        }
        this.$echarts.dispose(chartDom);
        let myChart = this.$echarts.init(chartDom, { color: this.colorListBar });
        this.yAxis.forEach((item, index) => {
          item.nameTextStyle = {
            color: this.colorListBar[index]
          }
          item.axisLabel.color = this.colorListBar[index]
        })
        myChart.setOption(this.getOption);
      },
      statsTypeChange() {
        let tabData = []
        const { statsType } = this.queryParams
        if (statsType == 1) {
          tabData = [...this.allData.salaryDeptSumResultList]
          this.yAxis[0].name = '部门总体工资'
          this.yAxis[1].name = '部门人均工资'
          this.series[0].name = '工资总额'
          this.series[1].name = '人均工资'
        }
        if (statsType == 2) {
          tabData = [...this.allData.fixDeptSumResultList]
          this.yAxis[0].name = '固定工资及补贴总额'
          this.yAxis[1].name = '人均固定工资及补贴'
          this.series[0].name = '固定工资及补贴总额'
          this.series[1].name = '人均固定工资及补贴'
        }
        if (statsType == 3) {
          tabData = [...this.allData.bonusDeptSumResultList]
          this.yAxis[0].name = '部门总体奖金'
          this.yAxis[1].name = '部门人均奖金'
          this.series[0].name = '奖金总额'
          this.series[1].name = '人均奖金'
        }
        if (statsType == 4) {
          tabData = [...this.allData.allDeptSumResultList]
          this.yAxis[0].name = '部门人工成本'
          this.yAxis[1].name = '人均人工成本'
          this.series[0].name = '人工成本总额'
          this.series[1].name = '人均人工成本'
        }
        const deptCategorize = this.queryParams.type == 1 ? '业务' : '职能'
        const seriesData0 = []
        const seriesData1 = []
        const xAxisData = []
        tabData.forEach(item => {
          if (item.deptCategorize == deptCategorize) {
            const deptState = validatenull(item.deptState) ? '' : `（${ item.deptState }）`
            seriesData0.push(item.allCost)
            seriesData1.push(item.avgCost)
            xAxisData.push(`${ item.deptName }${ deptState }`)
          }
        })
        this.series[0].data = seriesData0
        this.series[1].data = seriesData1
        this.xAxis.data = xAxisData
        this.initChart()
      }
    },
    computed: {
      ...mapGetters(['colorListBar']),
      getOption() {
        return {
          grid: { ...this.grid },
          legend: { ...this.legend },
          tooltip: { ...this.tooltip },
          xAxis: { ...this.xAxis },
          yAxis: [...this.yAxis],
          series: [...this.series]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    height: 400px;
  }
  .query-item {
    width: 130px;
  }
</style>
